import type { ClaimCycle, ClaimScheduleType } from '@paid-ui/types/payment-schedule';

import { utc2Mel } from './datetime';

interface ScheduleLike {
  claimScheduleType?: ClaimScheduleType;
  claimCycle?: ClaimCycle | null;
}

/** Claims fall due by a claim cycle (weekly, fortnightly or monthly) rather than a day of the month. */
export const isFrequencyBasedSchedule = (schedule?: ScheduleLike | null) =>
  schedule?.claimScheduleType === 'FREQUENCY';

/**
 * Names a periodic claim by the work it covers. A monthly claim keeps the month ("October"), as
 * day-of-month claims always have. Weekly and fortnightly claims share a month, so they get their
 * period instead: "1–14 Oct", or "28 Oct – 10 Nov" across a month, with the year only across a year.
 */
export const getClaimPeriodName = (
  schedule: ScheduleLike | null | undefined,
  startDate?: string,
  endDate?: string,
) => {
  if (!endDate) return '';

  const end = utc2Mel(endDate);
  if (schedule?.claimCycle?.frequency === 'MONTHLY' || !startDate) {
    return end.format('MMMM');
  }

  const start = utc2Mel(startDate);
  if (start.year() !== end.year()) {
    return `${start.format('D MMM YYYY')} – ${end.format('D MMM YYYY')}`;
  }
  if (start.month() !== end.month()) {
    return `${start.format('D MMM')} – ${end.format('D MMM')}`;
  }
  return `${start.format('D')}–${end.format('D MMM')}`;
};
